const replacer = [
    {
        token: /%\[woom\]%/g,
        replace: '<span class="woom-icon">woom</span>',
    },
    {
        token: /%\[([1-6])\]%/g,
        replace: '<span class="woom-icon number">$1</span>',
    },
    {
        token: /%\[mobile:(.*?)\]%/gi,
        replace: '<span class="lg:hidden">$1</span>',
    },
    {
        token: /%\[desktop:(.*?)\]%/gi,
        replace: '<span class="max-lg:hidden">$1</span>',
    },
    {
        token: /%\[(.*?)\]\((.*?)\)%/g,
        replace: '<a href="$2">$1</a>',
    },
    {
        token: /%\[redCharity\]%/g, // %[redCharity]%
        replace: '<span>(woom)<sup>RED</sup></span>',
    },
];

const woomTransformers: Record<string, (value: string) => string> = {
    '%[': (value: string) => {
        for (const rep of replacer) {
            value = value.replace(rep.token, rep.replace);
        }
        return value;
    },
    /**
     * book font
     */
    '%(': (value: string) => {
        return value.replace(/%\(/gi, '<span class="font-book">').replace(/\)%/gi, '</span>');
    },
    /**
     * bold font
     */
    '%{': (value: string) => {
        return value.replace(/%{/gi, '<span class="font-bold">').replace(/}%/gi, '</span>');
    },
    /**
     * %text - link %
     */
    '%': (value: string) => {
        return value.replace(/%(.*?) - (.*?)%/g, '<a href="$2" target="_blank">$1</a>');
    },
};

export const hasWoomTransformer = (value: string) => {
    return Object.keys(woomTransformers).some((trigger) => value.includes(trigger));
};

export const woomTextFormat = (value: string, removePTags?: boolean) => {
    if (typeof value === 'string') {
        for (const transformKey in woomTransformers) {
            if (value.includes(transformKey)) value = woomTransformers[transformKey](value);
        }
    }
    /** Use only for exceptional cases where the US team requires rich text formatting within headings */
    if (removePTags) {
        return value.replace(/<\/?p>/g, '');
    }
    return value;
};

// Regular expression to identify HTML tags in the string and &nbsp;. Replacing the identified HTML tag with a null string.
export const removeTags = (htmlText: string | null | undefined) => {
    if (!htmlText) return '';
    return htmlText.replace(/\u00A0/g, ' ').replace(/(<([^>]+)>)/gi, '');
};

/**
 * strips all woom text format
 * we need to manually infere type string
 * @param {string} value
 * @returns {string}
 */
export const removeWoomTextFormat = (value: string | null | undefined) => {
    return value ? removeTags(woomTextFormat(value)) : '';
};

export const textToId = (text: string) => {
    return text
        .toLowerCase() // Convert to lowercase
        .replace(/[^a-z0-9/]+/g, '-') // Replace non-alphanumeric characters and slashes with hyphens
        .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
};

export const capitalize = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
